// @flow
import type { GradProgram as ApiGradProgram } from 'api/orgAdmin';
import type { Action } from '../../actions/orgDashboard/gradPrograms';

export type GradProgram = {
  ...$Exact<ApiGradProgram>,
  isFetching: boolean
};

export type State = {
  byOrgId: {
    [string]: GradProgram
  }
};

const initialState = { byOrgId: {} };

export default function gradPrograms(
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_REQUEST':
      return {
        byOrgId: {
          ...state.byOrgId,
          [action.orgId]: {
            ...state.byOrgId[action.orgId],
            isFetching: true
          }
        }
      };
    case 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_SUCCESS':
      return {
        byOrgId: {
          ...state.byOrgId,
          [action.orgId]: {
            ...action.gradProgram,
            isFetching: false
          }
        }
      };
    case 'ORG_DASHBOARD_RESET_GRAD_PROGRAMS': {
      return initialState;
    }
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
